import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import ReplayIcon from '@mui/icons-material/Replay';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const steps = [
  {
    key: 'live',
    label: '1 en vivo',
    sublabel: 'Miércoles 7:00 PM',
    icon: LiveTvIcon,
  },
  {
    key: 'rep1',
    label: 'Reposición 1',
    sublabel: '',
    icon: ReplayIcon,
  },
  {
    key: 'rep2',
    label: 'Reposición 2',
    sublabel: '',
    icon: ReplayIcon,
  },
  {
    key: 'rep3',
    label: 'Reposición 3',
    sublabel: '',
    icon: ReplayIcon,
  },
  {
    key: 'ondemand',
    label: 'On-demand',
    sublabel: 'Plataforma TNO',
    icon: OndemandVideoIcon,
  },
];

const TransmissionFlow = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Box sx={{ mt: 2, mb: 4 }}>
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
        gutterBottom
        color="primary"
        align="center"
      >
        Ciclo de transmisión
      </Typography>
      <Typography
        component="h3"
        variant="h5"
        fontWeight={700}
        align="center"
        color="primary"
        gutterBottom
      >
        1 en vivo, 3 reposiciones y on-demand
      </Typography>
      <Typography variant="body2" color="textSecondary" align="center" sx={{ mb: 3 }}>
        Cada programa se emite en vivo, se repone tres veces y luego queda disponible en la plataforma on-demand de TNO Network.
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: isMd ? 'row' : 'column',
          alignItems: 'center',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: isMd ? 0 : 2,
        }}
      >
        {steps.map((step, index) => {
          const Icon = step.icon;
          const isLast = index === steps.length - 1;
          return (
            <React.Fragment key={step.key}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minWidth: isMd ? 100 : '100%',
                  maxWidth: isMd ? 120 : 280,
                  px: 1.5,
                  py: 2,
                  borderRadius: 2,
                  border: `2px solid ${theme.palette.primary.main}`,
                  bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'background.paper',
                  boxShadow: 1,
                }}
              >
                <Box sx={{ color: theme.palette.primary.main, mb: 0.5 }}>
                  <Icon sx={{ fontSize: 32 }} />
                </Box>
                <Typography variant="subtitle2" fontWeight={700} align="center">
                  {step.label}
                </Typography>
                {step.sublabel && (
                  <Typography variant="caption" color="text.secondary" align="center">
                    {step.sublabel}
                  </Typography>
                )}
              </Box>
              {!isLast && (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mx: isMd ? 0.5 : 0,
                    my: isMd ? 0 : 0,
                    transform: isMd ? 'none' : 'rotate(90deg)',
                  }}
                >
                  <ArrowForwardIcon
                    sx={{
                      fontSize: 28,
                      color: theme.palette.primary.main,
                      opacity: 0.8,
                    }}
                  />
                </Box>
              )}
            </React.Fragment>
          );
        })}
      </Box>
    </Box>
  );
};

export default TransmissionFlow;
